package hk.com.vr360_demo2.webapp.component.home

import emotion.react.css
import js.coroutines.awaitCancellation
import kotlinx.browser.window
import mui.material.Button as MuiButton
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogTitle
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.iframe
import react.useEffectOnce
import react.useState
import web.cssom.Background
import web.cssom.Border
import web.cssom.Color
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.LineStyle
import web.cssom.Padding
import web.cssom.pct
import web.cssom.px
import web.cssom.vh
import web.cssom.vw
import kotlin.js.JSON
import kotlin.js.console
import kotlin.js.unsafeCast

external interface HomeProps : Props {
    var component: HomeComponent
}

private const val IFRAME_SRC =
    "http://localhost:8080/edit/0141jmwr?token=AAAAGhcN_nJBUFNfQ09NTU9OX1RPS0VOX1BSRUZJWF8yNgAAAZ4ANMBN"
private const val IFRAME_ORIGIN = "http://localhost:8080"

val HomeScreen = FC<HomeProps> {

        div{}
//    val (lastMessage, setLastMessage) = useState("等待 iframe 發送消息...")
//    val (showDialog, setShowDialog) = useState(false)
//    val (clickedAction, setClickedAction) = useState<String?>(null)
//
//    useEffectOnce {
//        val handler: (dynamic) -> Unit = { event ->
//            val origin = event.origin as? String
//            if (origin == IFRAME_ORIGIN) {
//                val data = event.data
//                val text = try {
//                    JSON.stringify(data)
//                } catch (_: dynamic) {
//                    data?.toString() ?: "<empty>"
//                }
//                setLastMessage(text)
//                console.log("iframe -> parent", data)
//
//                val source = data?.source as? String
//                val type = data?.type as? String
//                val action = data?.action as? String
//                if (source == "editor-rewrite" && type == "EDITOR_ACTION_CLICK") {
//                    setClickedAction(action)
//                    setShowDialog(true)
//                }
//            }
//        }
//
//        window.asDynamic().addEventListener("message", handler)
//        awaitCancellation {
//            window.asDynamic().removeEventListener("message", handler)
//        }
//    }
//
//    div {
//        css {
//            width = 100.vw
//            height = 100.vh
//            display = Display.flex
//            flexDirection = FlexDirection.column
//            padding = Padding(16.px, 16.px)
//            asDynamic().gap = "8px"
//        }
//
//        div {
//            css {
//                asDynamic().flex = "1"
//            }
//
//            iframe {
//                src = IFRAME_SRC
//                title = "vr360-editor"
//                css {
//                    width = 100.pct
//                    height = 100.pct
//                    border = Border(0.px, LineStyle.solid)
//                }
//            }
//        }
//
//        div {
//            css {
//                padding = Padding(8.px, 10.px)
//                background = "rgba(0,0,0,0.6)".unsafeCast<Background>()
//                color = Color("#ffffff")
//                asDynamic().borderRadius = "6px"
//            }
//            +"收到消息: $lastMessage"
//        }
//
//        Dialog {
//            open = showDialog
//            this.fullWidth = true
//            asDynamic().maxWidth = "xs"
//            onClose = { _, _ -> setShowDialog(false) }
//
//            DialogTitle {
//                +"收到編輯器動作消息"
//            }
//            DialogContent {
//                +"點擊的 action: ${clickedAction ?: "-"}"
//            }
//            DialogActions {
//                MuiButton {
//                    variant = mui.material.ButtonVariant.contained
//                    onClick = { setShowDialog(false) }
//                    +"關閉"
//                }
//            }
//        }
//    }
}
